/*
 * File: AppointmentsToolbar.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Displays and styles the header (including the view name and filter icon) in Patient > Appointments & Follow Ups > Patient Appointments
 */
import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { Toolbar, IconButton, Button } from "@material-ui/core";
import FilterListIcon from "@material-ui/icons/FilterList";
import UIDialog from "components/ui/UIDialog";
import CloseIcon from "@material-ui/icons/Close";
import AppointmentFilterForm from "./AppointmentFilterForm";
import PatientChart from "../topofthechart/PatientChart";
import MainHeader from "components/MainHeader";
import { StoreContext } from "utils/useStore";
import User from "Store";

const styles = theme => ({
  icon: {
    color: theme.palette.common.black
  },
  filterIconContainer: {
    position: "absolute",
    right: theme.spacing(2),
    marginLeft: theme.spacing(2),
    bottom: theme.spacing(1.25)
  },
  toolbar: {
    padding: theme.spacing(2.5),
    display: "block",
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(2.5)
  },
  save: {
    width: "90%",
    background: theme.palette.common.buttonGradient,
    color: theme.palette.common.white
  }
});

class AppointmentsToolbar extends React.Component {
  state = { filterDialogIsOpen: false };

  static contextType = StoreContext;

  toggleDialog = () => {
    this.setState({ filterDialogIsOpen: !this.state.filterDialogIsOpen });
  };

  saveChanges = () => {
    this.props.filterModel.saveInLocalStorage(this.context.getStore(User));
    this.props.fetchAppointments();
    this.toggleDialog();
  };

  rightNav = () => {
    return <CloseIcon onClick={this.toggleDialog} color="inherit" />;
  };

  filterForm = () => {
    return <AppointmentFilterForm filterModel={this.props.filterModel} />;
  };

  actions = () => {
    let { classes } = this.props;
    return (
      <React.Fragment>
        <Button
          variant="contained"
          onClick={this.saveChanges}
          className={classes.save}
        >
          Apply
        </Button>
      </React.Fragment>
    );
  };

  render() {
    let { classes } = this.props;
    let { filterDialogIsOpen } = this.state;
    return (
      <React.Fragment>
        <PatientChart />
        <div>
          <UIDialog
            open={filterDialogIsOpen}
            title="Filter Patient Appointments"
            rightNav={this.rightNav}
            content={this.filterForm}
            actions={this.actions}
          />

          <React.Fragment>
            <Toolbar className={classes.toolbar}>
              <MainHeader
                pageTitle="Patient Appointments"
                pageSubtitle="Appointments & Follow-Ups"
              />
              <div className={classes.filterIconContainer}>
                <IconButton onClick={this.toggleDialog} color="inherit">
                  <FilterListIcon className={classes.icon} />
                </IconButton>
              </div>
            </Toolbar>
          </React.Fragment>
        </div>
      </React.Fragment>
    );
  }
}

AppointmentsToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  filterModel: PropTypes.object.isRequired,
  fetchAppointments: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
};

export default withStyles(styles)(AppointmentsToolbar);
